module.exports = __webpack_public_path__ + "img/a74c523d7f5d48ba80663c065cdbec80.bb5dc09b.jpg";